/**
 * Auth barrel export - re-exports useAuth from the correct provider
 * based on VITE_AUTH_MODE environment variable.
 *
 * All components should import from here:
 *   import { useAuth } from '../contexts/auth';
 */

const isDevAuth = import.meta.env.VITE_AUTH_MODE === 'dev';

export const { useAuth } = isDevAuth
  ? await import('./DevAuthContext')
  : await import('./ClerkAuthContext');
